import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'
import { isLoader } from "Modules/Loader"

const initialState = Immutable.Map({})
	.set('Search', new Immutable.List([]))
	.set('Response', new Immutable.List([]))
	.set('Get', new Immutable.Map({ donatarias: [], totalDonantes: [] }))
	.set('Certificate', new Immutable.Map({}))

/* Types */
export const GET_PRE_DONATION_EVENTS = 'GET_PRE_DONATION_EVENTS'
export const GET_PRE_CALCULATIONS = 'GET_PRE_CALCULATIONS'
export const GET_PRE_CALCULATION_DETAIL = 'GET_PRE_CALCULATION_DETAIL'
export const CERTIFICATE_CALCULATION = 'CERTIFICATE_CALCULATION'

/* Reducer*/
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_PRE_DONATION_EVENTS:
			return state.set('Search', new Immutable.List(action.Obj))
		case GET_PRE_CALCULATIONS:
			return state.set('Response', new Immutable.List(action.Obj))
		case GET_PRE_CALCULATION_DETAIL:
			return state.set('Get', new Immutable.Map(action.Obj))
		case CERTIFICATE_CALCULATION:
			return state.set('Certificate', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};


/* Action Creators */

export const getPreDonationsEvents = () => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/getPreDonationsEvents',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_PRE_DONATION_EVENTS, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getPreCalculations = (idDonataria) => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/getPreCalculations',
			method: "POST",
			data: { idDonataria },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_PRE_CALCULATIONS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const calculationPreDonation = (form) => {

	let temp = {
		usuario: sessionStorage.uid,
		configuracionFuncionId: form.configuracionFuncionId || null,
		corridaId: form.corrida,
		evaluaciones: form.evaluaciones ? form.evaluaciones.split(',') : [],
		funcion: form.funcion,
		funcionId: form.funcionId,
		redondeo: form.redondeo,
		redondeoId: form.redondeoId
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/calculationPreDonation',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const asignarMontosDonativoPre = (form) => {


	return (dispatch) => {
		dispatch(isLoader(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/asignarMontosDonativoPre',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoader(false))
			return response.data
		}).catch(error => {
			dispatch(isLoader(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getPreCalculationDetail = (form) => {

	let temp = {
		corridaId: form.corrida,
		configuracionId: form.item.configuracionId,
		funcionId: form.item.funcionId
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/getPreCalculationDetail',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_PRE_CALCULATION_DETAIL, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updatePreDonationGrantee = (form) => {

	let temp = {
		usuario: sessionStorage.uid,
		corridaId: form.corrida,
		configuracionId: form.item.configuracionId,
		funcionId: form.item.funcionId,
		donatariaId: form.donatariaId,
		donativoPre: parseFloat(form.montoDonativoPre)
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/updatePreDonationGrantee',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const exportPreDonationDetail = (form) => {

	let temp = {
		corridaId: form.corrida,
		configuracionId: form.item.configuracionId,
		funcionId: form.item.funcionId,
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/exportPreDonationDetail',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(response => {
			dispatch(isLoading(false))
			
			const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const fileName = `donativoPre-corrida-${temp.corridaId}-${Utils.getToday()}.xlsx`
			const objectUrl = URL.createObjectURL(blob)
			const a = document.createElement('a')

			a.href = objectUrl
			a.download = fileName
			document.body.appendChild(a)
			a.click()

			document.body.removeChild(a)
			URL.revokeObjectURL(objectUrl)

		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateStatusCalculationDetail = (form) => {

	let temp = {
		usuario : {
			idUsuario : sessionStorage.uid
		},
		idCorrida : form.corrida,
		descripcionOportunidad: form.descripcionOportunidad,
		idConfiguracion : form.item.configuracionId,
		idFuncion : form.item.funcionId,
		comentarios: form.comentarios || "",
		idEstado : form.statusUpdated
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/updateStatusCalculationDetail',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getCertificateCalculation = (form) => {

	let temp = {
		corridaId: form.corrida,
		funcionId: form.item.funcionId,
		configuracionFuncionId: form.item.configuracionId
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/getCertificateCalculation',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: CERTIFICATE_CALCULATION, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const saveCertificateCalculation = (form) => {

	let temp = {
		configuracionFuncionId: form.item.configuracionId,
		funcionId: form.item.funcionId,
		corridaId: form.corrida,
		certificadoId: form.certificadoId ? form.certificadoId : 0,
		dropboxId: form.logotipo || null,
		texto1: form.texto1,
		texto2: form.texto2,
		texto3: form.texto3,
		texto4: form.textEditor,
		texto5: form.texto5,
		texto6: form.texto6,
		texto7: form.texto7,
		piePagina: form.pieDePagina,
		firma1: form.firma1,
		firma2: form.firma2,
		firma3: form.texto7Firma1,
		firma4: form.texto7Firma2,
		usuario: sessionStorage.uid
	}

	temp.participantesDTO = []
	temp.equiposTrabajoDTO = []

	form.signs.map((item) => {
		temp.participantesDTO.push({
			apellidoMaterno: item.maternoOriginal,
			apellidoPaterno: item.paternoOriginal,
			nombre: item.nombreOriginal,
			puesto: item.puesto,
			titulo: item.titulo
		})
	})

	form.body.map((item) => {
		let auxArrayParticipantes = []

		item.original.map(data => {
			auxArrayParticipantes.push({ firmaParticipanteEquipo: data.firma })
		})

		temp.equiposTrabajoDTO.push({
			participantesEquipoDTO: auxArrayParticipantes,
			texto8: item.texto8,
			texto9: item.texto9
		})
	})

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/saveCertificateCalculation',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const generateCertificateCalculation = (form) => {

	let temp = {
		configuracionFuncionId: form.item.configuracionId,
		funcionId: form.item.funcionId,
		corridaId: form.corrida,
		usuario: sessionStorage.uid
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/donativoPre/generateCertificateCalculation',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(response => {
			dispatch(isLoading(false))

			const blob = new Blob([response.data], { type: 'application/pdf' })
			const fileName = `certificado DonativoPre-corrida-${form.corrida}${Utils.getToday()}.pdf`
			const objectUrl = URL.createObjectURL(blob)
			const a = document.createElement('a')

			a.href = objectUrl
			a.download = fileName
			document.body.appendChild(a)
			a.click()

			document.body.removeChild(a)
			URL.revokeObjectURL(objectUrl)
			
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearCalculationDetail = () => {

	return (dispatch) => {
		dispatch({ type: GET_PRE_CALCULATIONS, Obj: [] })
		dispatch({ type: GET_PRE_CALCULATION_DETAIL, Obj: { donatarias: [], totalDonantes: [] } })
		return Promise.resolve()
	}
}

export const clearAllData = () => {

	return (dispatch) => {
		dispatch({ type: GET_PRE_DONATION_EVENTS, Obj: [] })
		dispatch({ type: GET_PRE_CALCULATIONS, Obj: [] })
		dispatch({ type: GET_PRE_CALCULATION_DETAIL, Obj: { donatarias: [], totalDonantes: [] } })
		return Promise.resolve()
	}
}



// WEBPACK FOOTER //
// ./src/modules/PreDonation/Calculation.js